export type { FacilityContactDto } from '@umss/shared/data-access';
